<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    elementuiIcon: {
      type: Boolean,
      default: false
    }
  },
  render(h, context) {
    const { icon, title, elementuiIcon } = context.props
    const vnodes = []
    if (icon && !elementuiIcon) {
      vnodes.push(<svg-icon icon-class={icon}/>)
    } else {
      vnodes.push(<i class={icon + ' svg-icon'} style='color: currentColor;font-size:14px;width:15px;' />)
    }

    if (title) {
      vnodes.push(<span slot='title'>{(title)}</span>)
    }
    return vnodes
  }
}
</script>

<style lang="scss" scoped>

</style>
